var _style, _g, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoloPlayerBrown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215.85 281.29",
    style: {
      enableBackground: "new 0 0 215.85 281.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#010101;stroke-width:4.8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#C49A6C;stroke:#010101;stroke-width:4.8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#010101;}\n\t\n\t\t.st3{fill:none;stroke:#010101;stroke-width:4.8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:2.2222,11.111;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.17,89.21c1.35,5.03,2.2,10.34,2.52,15.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.78,89.21c-1.35,5.03-2.2,10.34-2.52,15.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.81,126.57c3.06,14.75,10.12,27.39,19.59,35.82c2.3,2.08,4.74,3.89,7.3,5.41 c6.28,3.76,13.27,5.86,20.65,5.86c0.04,0,0.07,0,0.11,0c0.04,0,0.09,0,0.11,0h0.02c0,0,0,0,0.02,0c0.02,0,0.06,0,0.11,0 c0.04,0,0.09,0,0.11,0c0.02,0,0.02,0,0.02,0h0.02c0.02,0,0.07,0,0.11,0c0.04,0,0.09,0,0.11,0h0.02c0,0,0,0,0.02,0 c0.02,0,0.07,0,0.11,0c0.04,0,0.09,0,0.11,0c0.02,0,0.02,0,0.02,0h0.02c0.02,0,0.07,0,0.11,0c0.04,0,0.06,0,0.11,0 c7.38,0,14.38-2.1,20.65-5.86c2.56-1.52,5-3.32,7.3-5.41c9.47-8.43,16.53-21.06,19.59-35.82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.69,105.07c5.04,0.93,8.84,5.37,8.84,10.66c0,5.87-4.61,10.6-10.38,10.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.26,105.07c-5.04,0.93-8.84,5.37-8.84,10.66c0,5.87,4.61,10.6,10.38,10.84"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.6,245.52c0-0.02,0-0.06,0-0.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.35,245.52c0-0.02,0-0.06,0-0.08"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.98,144.26c3.92,3.94,9.15,6.13,14.48,6.36c0.04,0,0.08,0,0.12-0.01c0.04,0,0.08,0,0.13,0.01 c0,0,0.01,0,0.01,0c0,0,0,0,0.01,0c0.04,0,0.08,0,0.12-0.01c0.04,0,0.08,0,0.13,0.01l0,0c0,0,0,0,0,0c0.04,0,0.08,0,0.13-0.01 c0.04,0,0.08,0,0.12,0.01c0,0,0,0,0.01,0c0,0,0,0,0.01,0c0.04,0,0.08,0,0.13-0.01c0.04,0,0.08,0,0.12,0.01 c5.33-0.24,10.56-2.43,14.48-6.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.62,112.71c-4.73-4.76-12.16-4.5-16.51-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.33,112.71c4.73-4.76,12.16-4.5,16.51-0.14"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.33,90.66c4.11,6.01,11.61,14.41,21.36,14.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.62,90.66c-4.11,6.01-11.61,14.41-21.36,14.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.6,245.52c0-0.02,0-0.06,0-0.08c0.01-3.48,0.02-6.96-0.01-10.39c-0.1-19.74-1.28-37.74-10-43.3 c-2.3-1.47-6.22-3.73-10.95-6.36v-0.01c-8.13-4.52-18.64-10.16-27.39-14.79c-9.5-5.05-16.92-8.91-16.92-8.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.35,245.52c0-0.02,0-0.06,0-0.08c-0.01-3.48-0.02-6.96,0.01-10.39c0.1-19.74,1.28-37.74,10-43.3 c2.3-1.47,6.22-3.73,10.95-6.36v-0.01c8.13-4.52,18.64-10.16,27.39-14.79c9.5-5.05,16.92-8.91,16.92-8.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.34,161.68l22.64,11.98c0,0-1.03,38.28-21.16,50.28l-18.71-23.04 C123.11,200.9,149.85,187.97,140.34,161.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.61,161.68l-22.64,11.98c0,0,1.03,38.28,21.16,50.28l18.71-23.04C98.84,200.9,72.1,187.97,81.61,161.68z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "89.14,212.84 101.44,238.47 101.95,261.44 120,261.44 120.51,238.47 132.81,212.84  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "123.11,200.9 110.98,223.01 98.84,200.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.59,191.75c0,0-24.32,20.36-24.32,38.34c0,11,0,31.31,0,31.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.36,191.75c0,0,24.32,20.36,24.32,38.34c0,11,0,31.31,0,31.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.98,238.27c0.17-0.03,0.34-0.04,0.52-0.04c1.73,0,3.13,1.4,3.13,3.13s-1.4,3.13-3.13,3.13 c-0.18,0-0.35-0.01-0.52-0.04c-0.17,0.03-0.34,0.04-0.52,0.04c-1.73,0-3.13-1.4-3.13-3.13s1.4-3.13,3.13-3.13 C110.63,238.23,110.81,238.24,110.98,238.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M110.98,250.35c0.17-0.03,0.34-0.04,0.52-0.04c1.73,0,3.13,1.4,3.13,3.13c0,1.73-1.4,3.13-3.13,3.13 c-0.18,0-0.35-0.01-0.52-0.04c-0.17,0.03-0.34,0.04-0.52,0.04c-1.73,0-3.13-1.4-3.13-3.13c0-1.73,1.4-3.13,3.13-3.13 C110.63,250.31,110.81,250.32,110.98,250.35z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 171.27,
    y1: 245.44,
    x2: 205.6,
    y2: 245.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.68,
    y1: 245.44,
    x2: 16.35,
    y2: 245.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 171.27,
    y1: 235.05,
    x2: 205.59,
    y2: 235.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 50.68,
    y1: 235.05,
    x2: 16.36,
    y2: 235.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 201.02,
    y1: 245.44,
    x2: 201.02,
    y2: 261.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20.93,
    y1: 245.44,
    x2: 20.93,
    y2: 261.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.35,77.54c0-43.84-13.39-60.54-54.38-60.54C69.99,17,56.6,33.7,56.6,77.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.98,71.28c18.02,0,50.57,0.9,54.38,5.43l7.46,6.1c0.97,0.79,1.32,2,0.91,3.1 c-0.41,1.1-1.52,1.89-2.84,2.03c-11.98,1.31-36.99,3.7-59.9,3.7c-22.91,0-47.91-2.39-59.89-3.7c-1.32-0.14-2.43-0.93-2.85-2.03 c-0.42-1.1-0.06-2.3,0.91-3.1l7.45-6.1C60.4,72.18,92.96,71.28,110.98,71.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.87,87.94l-5.38,53.36c-1.05,10.42-7.34,19.65-16.67,24.41c-8.26,4.22-20.42,7.85-37.84,7.94 c-17.42-0.09-29.58-3.72-37.84-7.94c-9.33-4.76-15.62-13.99-16.67-24.41l-5.38-53.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 110.98,
    y1: 71.28,
    x2: 110.98,
    y2: 17.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M145.77,72.47c0,0,0.4-55.43-31.15-55.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.18,72.47c0,0-0.4-55.43,31.15-55.43"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.36,
    y: 235.05,
    className: "st1",
    width: 34.32,
    height: 10.38
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171.27,
    y: 235.05,
    className: "st1",
    width: 34.32,
    height: 10.38
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoloPlayerBrown);
export default __webpack_public_path__ + "static/media/PoloPlayerBrown.dd509b93dadac1a868d69057d59b6c93.svg";
export { ForwardRef as ReactComponent };